import React from "react";
import PropTypes from "prop-types";
import Channel from "arena/components/Channel";
import ProxyPageOverrideContext from "arena/components/ProxyPage/ProxyPageOverrideContext";

/**
 * Содержимое диалога /tv/:slug. Один и тот же компонент и для обычного
 * адреса канала, и для прокси-страницы канала: после перехода с прокси на
 * настоящий адрес меняются только пропсы, Channel и плеер остаются
 * смонтированными. На прокси-странице сверху подставляются её SEO-поля.
 */
export default function ChannelDialogContent({ proxyChannel, ...matchProps }) {
  return (
    <ProxyPageOverrideContext.Provider value={proxyChannel?.override || null}>
      <Channel {...matchProps} proxyPage={proxyChannel?.page} />
    </ProxyPageOverrideContext.Provider>
  );
}

ChannelDialogContent.propTypes = {
  proxyChannel: PropTypes.shape({
    page: PropTypes.object,
    override: PropTypes.object,
  }),
};
